import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isMobileScreen } from '@apply/ui';
import { IconButton, IconButtonTheme, IconButtonSize } from '@apply/components';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { ApplyApi, IUserNoticeCount } from '@apply/api/src/api/ApplyApi';
import { applicationInsights } from '../../ApplicationInsights';

const mobileScreen = isMobileScreen();

export const NotificationButton: React.FC<{ printMode?: boolean }> = ({ printMode = false }) => {
    const navigate = useNavigate();
    const applyApi = new ApplyApi(applicationInsights);

    const [noticeCounts, set_noticeCounts] = React.useState<IUserNoticeCount>();
    const [loading, set_loading] = useState(false);
    const [loadingError, set_loadingError] = useState('');

    const loadNotices = async () => {
        const response = await applyApi.userNotices();
        if (response.statusCode !== 200) {
            set_loading(false);
            set_loadingError('Notice Counts failed to load.');
        } else {
            set_loadingError('');
            set_loading(false);
            set_noticeCounts(response.result);
        }
    };

    useEffect(() => {
        loadNotices();
    }, []);

    const notificationsClick = (e: React.MouseEvent) => {
        navigate('/notices');
    };

    const getNoticeCountHint = () => {
        if (loading) {
            return 'Notice Counts are loading...';
        } else {
            if (loadingError) {
                return loadingError;
            } else {
                if (noticeCounts?.total == 0) {
                    return 'You have no notices.';
                } else {
                    return `You have ${noticeCounts?.total} notices (${noticeCounts?.unread} unread)`;
                }
            }
        }
    };

    const renderNotificationsButton = (printMode: boolean) => {
        if (!printMode) {
            if (!mobileScreen) {
                return (
                    <IconButton
                        id='notificationsButton'
                        theme={IconButtonTheme.White}
                        size={IconButtonSize.Medium}
                        icon={faBell}
                        handleClick={notificationsClick}
                        bubbleNumber={noticeCounts?.unread}
                        hint={getNoticeCountHint()}
                    ></IconButton>
                );
            } else {
                return (
                    <IconButton
                        id='notificationsButton'
                        theme={IconButtonTheme.Transparent}
                        size={IconButtonSize.Small}
                        icon={faBell}
                        handleClick={notificationsClick}
                        bubbleNumber={noticeCounts?.unread}
                        hint={getNoticeCountHint()}
                    ></IconButton>
                );
            }
        }
    };

    return renderNotificationsButton(printMode);
};
